import { useCallback } from 'react';

import { useSidebarStore } from '../store/store';

export const useIsChildOpen = () => {
  const { isChildOpen: isChildOpenRaw } = useSidebarStore();

  return useCallback(
    (key: string) => {
      return isChildOpenRaw.key === key && isChildOpenRaw.value;
    },
    [isChildOpenRaw],
  );
};
